import "../../../filterChoice/model/selectors/selectFilterHistory.js";
import "../../../filterChoice/model/selectors/selectFilterSortValue.js";
import { selectFilterValues } from "../../../filterChoice/model/selectors/selectFilterValues.js";
import "../../../filterChoice/model/selectors/selectFilterValuesCount.js";
import "../../../filterChoice/model/selectors/selectIsFilterValuesSelected.js";
import "../../../filterChoice/model/selectors/selectIsInitialSortValuesSelected.js";
import "../../../filterChoice/model/selectors/selectIsValidSortValuesSelected.js";
import "../../../filterChoice/model/selectors/selectSlugedFilterValues.js";
import "../../../../shared/lib/store/createAppApi.js";
import "../../../../shared/lib/store/createAppAsyncThunk.js";
import { createAppSelector } from "../../../../shared/lib/store/createAppSelector.js";
import "../../../../shared/lib/store/createAppSlice.js";
import "react";
import "redux";
import "../../../../shared/lib/store/hooks/useAppDispatch.js";
import "../../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../../shared/lib/store/hooks/useAppStore.js";
import "../../../../shared/store/config/model/selectors/selectBenefits.js";
import "../../../../shared/store/config/model/selectors/selectBooking.js";
import "../../../../shared/store/config/model/selectors/selectCredit.js";
import "../../../../shared/store/config/model/selectors/selectFilterGrid.js";
import { selectFilterGridItems } from "../../../../shared/store/config/model/selectors/selectFilterGridItems.js";
import "../../../../shared/store/config/model/selectors/selectFilters.js";
import "../../../../shared/store/config/model/selectors/selectGeolocator.js";
import "../../../../shared/store/config/model/selectors/selectLocationCollectionIds.js";
import "../../../../shared/store/config/model/selectors/selectMaps.js";
import "../../../../shared/store/config/model/selectors/selectModels.js";
import "../../../../shared/store/config/model/selectors/selectSort.js";
import "../../../../shared/store/config/model/selectors/selectTags.js";
import "../../../../shared/store/config/model/selectors/selectTradeIn.js";
import { createFilterQuery } from "../../lib/api/queries/createFilterQuery.js";
import { selectAllFilterValues } from "./selectAllFilterValues.js";
import { selectFilterImmutableQueries } from "./selectFilterImmutableQueries.js";
const selectAvailableFilterValuesQueries = createAppSelector(
  [selectAllFilterValues, selectFilterValues, selectFilterGridItems, selectFilterImmutableQueries],
  (allFilterValues, filterValuesChoice, filterGridItems, immutableQueries) => {
    const q = [...immutableQueries.q];
    const qMap = { ...immutableQueries.qMap };
    const { data: allFilterValuesItem } = allFilterValues;
    if (!allFilterValuesItem) {
      return { q, qMap };
    }
    if (filterGridItems.length) {
      filterGridItems.forEach((item) => {
        var _a;
        const query = createFilterQuery(item, (_a = allFilterValuesItem.data) == null ? void 0 : _a[item.key], filterValuesChoice == null ? void 0 : filterValuesChoice[item.key]);
        if (query) {
          q.push(query);
          qMap[item.key] = query;
        }
      });
    }
    return { q, qMap };
  }
);
export {
  selectAvailableFilterValuesQueries
};
